import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n/config';
// arsenal-tpms/frontend/src/components/vehicles/detail/SensorAssignmentDialog.jsx
import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    Alert,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    useMediaQuery,
    useTheme
} from '@mui/material';
import { Sensors as SensorIcon } from '@mui/icons-material';

const SensorAssignmentDialog = ({
    open,
    onClose,
    position,
    availableSensors,
    onAssign,
    assigning,
    t
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            fullScreen={isMobile}
        >
            <DialogTitle>
                {t('vehicles.sensorAssignment.title', 'Asignar Sensor')} {i18n.t('hardcoded.components_vehicles_detail_sensorassignmentdialog.-_pos')}{position}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ pt: 2 }}>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        {t('vehicles.sensorAssignment.description', 'Selecciona un sensor disponible')}
                    </Typography>

                    {availableSensors.length === 0 ? (
                        <Alert severity="warning" sx={{ mt: 2 }}>
                            {t('vehicles.sensorAssignment.noSensors', 'No hay sensores disponibles')}
                        </Alert>
                    ) : (
                        <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t('vehicles.sensorAssignment.sensorId', 'ID')}</TableCell>
                                        <TableCell align="center">{t('common.actions', 'Acciones')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {availableSensors.map((sensor) => (
                                        <TableRow key={sensor.id}>
                                            <TableCell>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <SensorIcon fontSize="small" color="primary" />
                                                    <Typography variant="body2">
                                                        {sensor.sensor_id || sensor.id.slice(-8)}
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                            <TableCell align="center">
                                                <Button
                                                    size="small"
                                                    variant="contained"
                                                    disabled={assigning}
                                                    onClick={() => onAssign(sensor.id, position)}
                                                >
                                                    {t('vehicles.sensorAssignment.assign', 'Asignar')}
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    {t('common.close', 'Cerrar')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SensorAssignmentDialog;